"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUploadAnalytics = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _trackingHelper = require("../tracking/trackingHelper");
var _helpers = require("./helpers");
var _types = require("./types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ANALYTICS_INTERVAL_MS = 10000;
var ERROR_TO_ERROR_TYPES = {
  dimensions: _types.FileInfoErrorType.IMAGE_TOO_SMALL,
  fileType: _types.FileInfoErrorType.WRONG_FILE_TYPE,
  size: _types.FileInfoErrorType.FILE_TOO_BIG,
  image: _types.FileInfoErrorType.NOT_IMAGE,
  default: _types.FileInfoErrorType.UNKNOWN,
  baddata: _types.FileInfoErrorType.INVALID_INPUT,
  upload: _types.FileInfoErrorType.NETWORK_ERROR,
  info: _types.FileInfoErrorType.INFO_NOT_LOADED,
  createGroup: _types.FileInfoErrorType.FILE_GROUP_CREATE_FAILED,
  deleted: _types.FileInfoErrorType.FILE_DELETED
};

// Returns a copy of a given object without all null and undefined properties
// TODO: make generic later
var withoutEmptyProps = function withoutEmptyProps(original) {
  var cleaned = {};
  Object.keys(original).forEach(function (key) {
    var value = original[key];
    if (value === null || value === undefined) return;
    cleaned[key] = value;
  });
  return cleaned;
};
var getUploadAnalytics = exports.getUploadAnalytics = function getUploadAnalytics(product, location, additionalUploadedFilesTrackingProperties, additionalUploadEventTrackingProperties) {
  var analyticsIntervalID;
  var allUploads = [];

  // Send an analytics event with status info about all uploads.
  var sendEvent = function sendEvent() {
    var untrackedUploads = allUploads.filter(function (u) {
      return !u.fileTrackingComplete;
    });
    var uploads = [];
    if (untrackedUploads.length === 0) return;
    untrackedUploads.forEach(function (fileInfo) {
      var _sourceInfo$source;
      var status = fileInfo.status,
        errorType = fileInfo.errorType,
        size = fileInfo.size,
        originalImageInfo = fileInfo.originalImageInfo,
        sourceInfo = fileInfo.sourceInfo,
        duration = fileInfo.duration;

      // Mark COMPLETE / ERROR / CANCELLED uploads as tracked to avoid resending them later.
      // eslint-disable-next-line no-param-reassign
      fileInfo.fileTrackingComplete = true;
      uploads.push(withoutEmptyProps(_objectSpread({
        status: status,
        error: errorType,
        product: product,
        location: location,
        size: size ? (0, _helpers.bytesToMB)(size) : 0,
        w: originalImageInfo === null || originalImageInfo === void 0 ? void 0 : originalImageInfo.width,
        h: originalImageInfo === null || originalImageInfo === void 0 ? void 0 : originalImageInfo.height,
        source: sourceInfo === null || sourceInfo === void 0 || (_sourceInfo$source = sourceInfo.source) === null || _sourceInfo$source === void 0 ? void 0 : _sourceInfo$source.toUpperCase(),
        duration: Math.round(duration / 1000)
      }, additionalUploadedFilesTrackingProperties)));
    });
    (0, _trackingHelper.trackEvent)('Upload Completed', _objectSpread({
      uploads: uploads
    }, additionalUploadEventTrackingProperties));
  };

  // If there is a pending analytics event, immediately send it and cancel the interval
  var stopAnalytics = function stopAnalytics() {
    if (analyticsIntervalID) {
      clearInterval(analyticsIntervalID);
      analyticsIntervalID = null;
      sendEvent();
    }
  };
  var startAnalytics = function startAnalytics(fileColl) {
    // eslint-disable-next-line no-underscore-dangle
    var widgetFiles = fileColl.__items;
    fileColl.onAdd.add(function (file) {
      var startTime = Date.now();

      // Whenever an upload starts, if the interval hasn't started, start it.
      if (!analyticsIntervalID) {
        analyticsIntervalID = typeof window !== 'undefined' ? window.setInterval(sendEvent, ANALYTICS_INTERVAL_MS) : null;
      }
      file.fail(function (error, fileInfo) {
        // 'user' errors mean that the user manually cancelled the upload. They shouldn't count as actual errors.
        allUploads.push(_objectSpread(_objectSpread({}, fileInfo), {}, {
          status: error === 'user' ? _types.FileInfoStatus.CANCELLED : _types.FileInfoStatus.ERROR,
          errorType: error === 'user' ? undefined : ERROR_TO_ERROR_TYPES[error],
          duration: Date.now() - startTime
        }));
      });
      file.done(function (fileInfo) {
        allUploads.push(_objectSpread(_objectSpread({}, fileInfo), {}, {
          status: _types.FileInfoStatus.COMPLETE,
          duration: Date.now() - startTime
        }));
      });
      file.always(function () {
        // When the LAST file completes, immediately stop interval and send event.
        var allFilesFinished = !widgetFiles.some(function (f) {
          return f.state() === 'pending';
        });
        if (allFilesFinished) {
          stopAnalytics();
        }
      });
    });
  };
  return {
    startAnalytics: startAnalytics,
    stopAnalytics: stopAnalytics
  };
};